import { JsonObject, JsonProperty } from 'json2typescript';

import { DeceasedInformation } from './deceased-information.model';
import { DeceasedMoreInformation } from './deceased-more-information.model';
import { InheritanceInformation } from './inheritance-information.model';
import { NotaryInformation } from './notary-information.models';
import { ReporterInformation } from './reporter-information.model';

@JsonObject('selfCareForm')
export class CustomerInformation {
  @JsonProperty('token', String, true)
  public token = '';

  @JsonProperty('savePage', String, true)
  public savePage = '';

  @JsonProperty('loadPage', String, true)
  public loadPage = '';

  @JsonProperty('deceasedInformations', DeceasedInformation, true)
  public deceasedInformations: DeceasedInformation | undefined = undefined;

  @JsonProperty('deceasedMoreInformations', DeceasedMoreInformation, true)
  public deceasedMoreInformations: DeceasedMoreInformation | undefined = undefined;

  @JsonProperty('reporterInformations', ReporterInformation, true)
  public reporterInformations: ReporterInformation | undefined = undefined;

  @JsonProperty('notaryInformations', NotaryInformation, true)
  public notaryInformations: NotaryInformation | undefined = undefined;

  @JsonProperty('inheritanceInformations', InheritanceInformation, true)
  public inheritanceInformations: InheritanceInformation | undefined = undefined;
}
